module.exports = __webpack_public_path__ + "static/media/user-hard-hat.2933cf0d.svg";